const LanguageActionTypes = {
  SET_LANGUAGE: 'SET_LANGUAGE',
}

export default LanguageActionTypes
